// import store from '@/view/store'

const routes = [
  {
    path: '/onboarding/',
    component: () => import('@/view/Layouts/Onboarding/default.vue'),
    children: [
      {
        path: 'person',
        component: () => import('@/view/pages/shared/onboarding/pages/CpfPage.vue'),
        meta: {
          layout: 'full',
        },
      },
      {
        path: 'init',
        component: () => import('@/view/pages/shared/onboarding/pages/EmailTelephonePage.vue'),
        meta: {
          layout: 'full',
        },
      },
      {
        path: 'start',
        meta: {
          layout: 'full',
        },
      },
      {
        path: 'email-mfa',
        component: () => import('@/view/pages/shared/onboarding/pages/EmailMfaPage.vue'),
        meta: {
          layout: 'full',
        },
      },
      {
        path: 'personal',
        component: () => import('@/view/pages/shared/onboarding/pages/PersonalDataPage.vue'),
        meta: {
          layout: 'stepper',
          step: 1,
        },
      },
      {
        path: 'attachments',
        component: () => import('@/view/pages/shared/onboarding/pages/AttachmentsPage.vue'),
        meta: {
          layout: 'stepper',
          step: 2,
        },
      },
      {
        path: 'waiting',
        component: () => import('@/view/pages/shared/onboarding/pages/WaitingPage.vue'),
      },
      {
        path: 'failed',
        component: () => import('@/view/pages/shared/onboarding/pages/FailedPage.vue'),
      },
      {
        path: 'success',
        component: () => import('@/view/pages/shared/onboarding/pages/SuccessPage.vue'),
      },
      {
        path: 'first-access',
        component: () => import('@/view/pages/shared/onboarding/pages/FirstAccessPage.vue'),
      },
      {
        path: 'company',
        component: () => import('@/view/pages/shared/onboarding/pages/company/Cpf&CnpjPage.vue'),
      },
      {
        path: 'company-init',
        component: () => import('@/view/pages/shared/onboarding/pages/EmailTelephonePage.vue'),
      },
      {
        path: 'company-data',
        component: () => import('@/view/pages/shared/onboarding/pages/company/CompanyDataPage.vue'),
        meta: {
          layout: 'stepper',
          step: 1,
        },
      },
      {
        path: 'company-members',
        component: () => import('@/view/pages/shared/onboarding/pages/company/CompanyMembers.vue'),
        meta: {
          layout: 'stepper',
          step: 1,
        },
      },
      {
        path: 'company-attachments',
        component: () => import('@/view/pages/shared/onboarding/pages/AttachmentsPage.vue'),
        meta: {
          layout: 'stepper',
          step: 2,
        },
      },
    ],
  },
]
export default routes
